export const FLYER_PLACEHOLDER_DESIGNS = [
  {
    key: 'strings',
    label: '弦の流れ',
    description: '斜線でクラシックな張りを出す',
  },
  {
    key: 'ornament',
    label: '装飾フレーム',
    description: '円と線で格式を強める',
  },
  {
    key: 'abstract-flow',
    label: '抽象ウェーブ',
    description: 'ゆるやかな流線で柔らかく見せる',
  },
  {
    key: 'piano-keys',
    label: '鍵盤モチーフ',
    description: '下辺のリズムで音楽性を出す',
  },
  {
    key: 'minimal-circle',
    label: 'ミニマル円面',
    description: '大きな面と余白で静けさを出す',
  },
  {
    key: 'leaf',
    label: '有機ライン',
    description: '曲線でやわらかい印象を作る',
  },
];

export const FLYER_PLACEHOLDER_COLORS = [
  {
    key: 'midnight-symphony',
    label: 'Midnight Symphony',
    background: 'linear-gradient(135deg, var(--slate-950) 0%, var(--flyer-placeholder-indigo-deep) 100%)',
    accent: 'var(--flyer-placeholder-gold-accent)',
    text: 'var(--slate-50)',
    mutedText: 'rgba(248, 250, 252, 0.72)',
    frame: 'rgba(248, 250, 252, 0.16)',
    overlay: 'radial-gradient(circle at 50% 20%, rgba(212, 175, 55, 0.08) 0%, transparent 72%)',
    fontFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
    monoFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
  },
  {
    key: 'royal-bordeaux',
    label: 'Royal Bordeaux',
    background: 'linear-gradient(135deg, var(--flyer-placeholder-red-deep) 0%, var(--flyer-placeholder-rose-deep) 100%)',
    accent: 'var(--amber-200)',
    text: 'var(--rose-50)',
    mutedText: 'rgba(255, 241, 242, 0.72)',
    frame: 'rgba(255, 241, 242, 0.16)',
    overlay: 'linear-gradient(to bottom, rgba(0,0,0,0.06), rgba(0,0,0,0.32))',
    fontFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
    monoFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
  },
  {
    key: 'dusty-rose',
    label: 'Dusty Rose',
    background: 'linear-gradient(to bottom, var(--flyer-placeholder-rose-soft) 0%, var(--rose-200) 100%)',
    accent: 'var(--rose-800)',
    text: 'var(--flyer-placeholder-rose-deep)',
    mutedText: 'rgba(136, 19, 55, 0.7)',
    frame: 'rgba(136, 19, 55, 0.14)',
    overlay: 'linear-gradient(to top, rgba(255,255,255,0.12), transparent 55%)',
    fontFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
    monoFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
  },
  {
    key: 'oxford-navy',
    label: 'Oxford Navy',
    background: 'linear-gradient(135deg, var(--flyer-placeholder-navy-deep) 0%, var(--blue-900) 100%)',
    accent: 'var(--blue-300)',
    text: 'var(--blue-50)',
    mutedText: 'rgba(239, 246, 255, 0.72)',
    frame: 'rgba(239, 246, 255, 0.16)',
    overlay: 'radial-gradient(circle at top right, rgba(255,255,255,0.08) 0%, transparent 60%)',
    fontFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
    monoFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
  },
  {
    key: 'forest-mist',
    label: 'Forest Mist',
    background: 'linear-gradient(135deg, var(--flyer-placeholder-emerald-deep) 0%, var(--emerald-800) 100%)',
    accent: 'var(--flyer-placeholder-emerald-accent)',
    text: 'var(--emerald-50)',
    mutedText: 'rgba(236, 253, 245, 0.72)',
    frame: 'rgba(236, 253, 245, 0.16)',
    overlay: 'radial-gradient(circle at 80% 10%, rgba(255,255,255,0.05) 0%, transparent 55%)',
    fontFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
    monoFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
  },
  {
    key: 'deep-slate',
    label: 'Deep Slate',
    background: 'linear-gradient(135deg, var(--flyer-placeholder-zinc-deep) 0%, var(--flyer-placeholder-zinc) 100%)',
    accent: 'var(--flyer-placeholder-zinc-soft)',
    text: 'var(--flyer-placeholder-zinc-subtle)',
    mutedText: 'rgba(244, 244, 245, 0.66)',
    frame: 'rgba(244, 244, 245, 0.12)',
    overlay: 'linear-gradient(180deg, rgba(255,255,255,0.04) 0%, transparent 58%)',
    fontFamily: '"Avenir Next", "Segoe UI", "Hiragino Sans", sans-serif',
    monoFamily: '"Avenir Next", "Segoe UI", "Hiragino Sans", sans-serif',
  },
  {
    key: 'ivory-recital',
    label: 'Ivory Recital',
    background: 'linear-gradient(to bottom, var(--flyer-placeholder-stone-subtle) 0%, var(--flyer-placeholder-stone-soft) 100%)',
    accent: 'var(--flyer-placeholder-stone-ink)',
    text: 'var(--flyer-placeholder-stone-ink)',
    mutedText: 'rgba(28, 25, 23, 0.68)',
    frame: 'rgba(28, 25, 23, 0.12)',
    overlay: 'linear-gradient(180deg, rgba(255,255,255,0.35) 0%, transparent 45%)',
    fontFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
    monoFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
  },
  {
    key: 'antique-cream',
    label: 'Antique Cream',
    background: 'linear-gradient(135deg, var(--orange-50) 0%, var(--orange-100) 100%)',
    accent: 'var(--orange-900)',
    text: 'var(--orange-900)',
    mutedText: 'rgba(124, 45, 18, 0.7)',
    frame: 'rgba(124, 45, 18, 0.14)',
    overlay: 'radial-gradient(circle at top left, rgba(255,255,255,0.22) 0%, transparent 58%)',
    fontFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
    monoFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
  },
  {
    key: 'noir-silver',
    label: 'Noir Silver',
    background: 'linear-gradient(135deg, var(--flyer-placeholder-black) 0%, var(--flyer-placeholder-neutral-deep) 100%)',
    accent: 'var(--flyer-placeholder-neutral-soft)',
    text: 'var(--flyer-placeholder-neutral-subtle)',
    mutedText: 'rgba(250, 250, 250, 0.72)',
    frame: 'rgba(250, 250, 250, 0.12)',
    overlay: 'radial-gradient(circle at center, rgba(255,255,255,0.06) 0%, transparent 70%)',
    fontFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
    monoFamily: '"Cormorant Garamond", "Times New Roman", Georgia, serif',
  },
];

export const FLYER_PLACEHOLDER_ALLOWED_COLOR_KEYS_BY_DESIGN = FLYER_PLACEHOLDER_DESIGNS.reduce(
  (accumulator, design) => ({
    ...accumulator,
    [design.key]: FLYER_PLACEHOLDER_COLORS.map((palette) => palette.key),
  }),
  {}
);

const DEFAULT_DESIGN_KEY = FLYER_PLACEHOLDER_DESIGNS[0].key;
const DEFAULT_COLOR_KEY = FLYER_PLACEHOLDER_COLORS[0].key;

const DESIGN_KEY_SET = new Set(FLYER_PLACEHOLDER_DESIGNS.map((item) => item.key));
const COLOR_KEY_SET = new Set(FLYER_PLACEHOLDER_COLORS.map((item) => item.key));

const normalizeKey = (value) =>
  String(value || '')
    .trim()
    .toLowerCase();

const toArray = (value) => (Array.isArray(value) ? value : []);

const firstNonEmptyString = (...values) =>
  values.find((value) => typeof value === 'string' && value.trim()) || '';

const toDateInputLabel = (value) => {
  if (!value) return '';
  if (typeof value === 'string') {
    const trimmed = value.trim();
    const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '';
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Tokyo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const parts = formatter.formatToParts(parsed);
  const year = parts.find((part) => part.type === 'year')?.value || '';
  const month = parts.find((part) => part.type === 'month')?.value || '';
  const day = parts.find((part) => part.type === 'day')?.value || '';
  return year && month && day ? `${year}-${month}-${day}` : '';
};

const looksLatin = (value) => /^[A-Za-z0-9 '&/.-]+$/.test(value || '');

const stripNoise = (value) =>
  String(value || '')
    .replace(/[\s\u3000]+/g, ' ')
    .replace(/[()（）【】「」『』［］[\]<>]/g, ' ')
    .trim();

const hashString = (input) => {
  const source = String(input || '');
  let hash = 5381;
  for (let index = 0; index < source.length; index += 1) {
    hash = (hash * 33) ^ source.charCodeAt(index);
  }
  return Math.abs(hash >>> 0);
};

export const normalizeFlyerPlaceholderDesignKey = (value) => {
  const normalized = normalizeKey(value);
  return DESIGN_KEY_SET.has(normalized) ? normalized : null;
};

export const normalizeFlyerPlaceholderColorKey = (value) => {
  const normalized = normalizeKey(value);
  return COLOR_KEY_SET.has(normalized) ? normalized : null;
};

export const isFlyerPlaceholderSelectionEditable = ({
  flyerFrontUrl,
  flyerFrontSourceEventUuid,
  useExistingFlyers,
} = {}) => !flyerFrontUrl && !flyerFrontSourceEventUuid && useExistingFlyers !== true;

export const getFlyerPlaceholderTitle = (event = {}) =>
  firstNonEmptyString(
    event?.eventTitle,
    event?.name,
    event?.event_name,
    event?.eventName,
    event?.title,
    event?.label
  ) || 'Untitled Event';

export const getFlyerPlaceholderDate = (event = {}) =>
  toDateInputLabel(firstNonEmptyString(
    event?.eventDate,
    event?.event_date,
    event?.date,
    event?.displayDate
  ));

export const getFlyerPlaceholderVenue = (event = {}) =>
  firstNonEmptyString(
    event?.venueName,
    event?.venue_name,
    event?.venue,
    event?.hallName
  );

export const getFlyerPlaceholderGenre = (event = {}) => {
  const direct = firstNonEmptyString(
    event?.genreLabel,
    event?.genre_label,
    event?.performanceType,
    event?.performance_type,
    event?.performance,
  );
  if (direct) return direct;
  const labels = toArray(event?.genre_labels || event?.genreLabels)
    .map((item) => firstNonEmptyString(item?.label, item?.name, item?.value, item))
    .filter(Boolean);
  return labels[0] || '';
};

export const getFlyerPlaceholderInitials = (title = '') => {
  const cleaned = stripNoise(title);
  if (!cleaned) return 'EV';
  if (looksLatin(cleaned)) {
    const tokens = cleaned.split(/[^A-Za-z0-9]+/).filter(Boolean);
    if (tokens.length >= 2) {
      return tokens
        .slice(0, 2)
        .map((token) => token.charAt(0).toUpperCase())
        .join('');
    }
    return cleaned.replace(/[^A-Za-z0-9]/g, '').slice(0, 3).toUpperCase() || 'EV';
  }
  return Array.from(cleaned.replace(/\s+/g, '')).slice(0, 2).join('') || '公演';
};

export const getFlyerPlaceholderShortTitle = (title = '') => {
  const cleaned = stripNoise(title);
  if (!cleaned) return 'イベント';
  if (looksLatin(cleaned)) {
    return cleaned.toUpperCase().slice(0, 18);
  }
  return cleaned.slice(0, 12);
};

export const resolveFlyerPlaceholderTheme = ({
  event = null,
  eventId,
  designKey,
  colorKey,
} = {}) => {
  const source = event && typeof event === 'object' ? event : {};
  const resolvedEventId = firstNonEmptyString(
    eventId,
    source?.event_uuid,
    source?.eventUuid,
    source?.id,
    source?.event_id,
    source?.eventId
  );
  const groupRootEventId = firstNonEmptyString(
    source?.original_event_uuid,
    source?.originalEventUuid,
    source?.group_root_event_uuid,
    source?.groupRootEventUuid
  );
  const title = getFlyerPlaceholderTitle(source);
  const explicitDesignKey = normalizeFlyerPlaceholderDesignKey(designKey);
  const explicitColorKey = normalizeFlyerPlaceholderColorKey(colorKey);
  const designKeyFromEvent = normalizeFlyerPlaceholderDesignKey(
    source?.flyer_placeholder_design_key ??
      source?.flyerPlaceholderDesignKey ??
      source?.placeholder_design_key ??
      source?.placeholderDesignKey ??
      source?.event_flyer_placeholder_design_key ??
      source?.eventFlyerPlaceholderDesignKey ??
      source?.performance_flyer_placeholder_design_key ??
      source?.performanceFlyerPlaceholderDesignKey ??
      source?.original_event_flyer_placeholder_design_key ??
      source?.originalEventFlyerPlaceholderDesignKey ??
      source?.parent_flyer_placeholder_design_key ??
      source?.parentFlyerPlaceholderDesignKey
  );
  const colorKeyFromEvent = normalizeFlyerPlaceholderColorKey(
    source?.flyer_placeholder_color_key ??
      source?.flyerPlaceholderColorKey ??
      source?.placeholder_color_key ??
      source?.placeholderColorKey ??
      source?.event_flyer_placeholder_color_key ??
      source?.eventFlyerPlaceholderColorKey ??
      source?.performance_flyer_placeholder_color_key ??
      source?.performanceFlyerPlaceholderColorKey ??
      source?.original_event_flyer_placeholder_color_key ??
      source?.originalEventFlyerPlaceholderColorKey ??
      source?.parent_flyer_placeholder_color_key ??
      source?.parentFlyerPlaceholderColorKey
  );
  const seedBaseId =
    explicitDesignKey || explicitColorKey || designKeyFromEvent || colorKeyFromEvent
      ? resolvedEventId
      : groupRootEventId || resolvedEventId;
  const seed = `${seedBaseId || title || 'event'}:${getFlyerPlaceholderDate(source) || ''}`;
  const designSeedIndex = hashString(seed) % FLYER_PLACEHOLDER_DESIGNS.length;
  const resolvedDesignKey =
    explicitDesignKey || designKeyFromEvent || FLYER_PLACEHOLDER_DESIGNS[designSeedIndex]?.key || DEFAULT_DESIGN_KEY;
  const allowedColorKeys =
    FLYER_PLACEHOLDER_ALLOWED_COLOR_KEYS_BY_DESIGN[resolvedDesignKey] ||
    FLYER_PLACEHOLDER_COLORS.map((palette) => palette.key);
  const resolvedColorKey =
    explicitColorKey ||
    colorKeyFromEvent ||
    allowedColorKeys[hashString(`${seed}:${resolvedDesignKey}`) % allowedColorKeys.length] ||
    DEFAULT_COLOR_KEY;
  const design =
    FLYER_PLACEHOLDER_DESIGNS.find((item) => item.key === resolvedDesignKey) ||
    FLYER_PLACEHOLDER_DESIGNS[0];
  const palette =
    FLYER_PLACEHOLDER_COLORS.find((item) => item.key === resolvedColorKey) ||
    FLYER_PLACEHOLDER_COLORS[0];
  return {
    design,
    palette,
    designKey: design.key,
    colorKey: palette.key,
  };
};
